import {BaseState, initBaseModule} from "./modules/base";
import Vue from "vue";
import Vuex from "vuex";
import {getStoreBuilder} from "vuex-typex";
import PlayServerClient from "../modules/PlayServerClient";
import {initGeoModule} from "./modules/geo";
import {hasWebuserSession} from "../modules/utils";
import {NativeApi} from "@/modules/NativeBridge";

export default interface RootState {
    base: BaseState;
}

export const initVuex = (serverClient: PlayServerClient, activeOrgnum: number, nativeApi: NativeApi) => {
    Vue.use(Vuex);
    const baseApi = initBaseModule(serverClient);
    const geoApi = initGeoModule(nativeApi);
    const storebuilder = getStoreBuilder<RootState>();
    const store = storebuilder.vuexStore();
    // start loading base state
    let loaders: Promise<any>[] = [];
    if(hasWebuserSession()) {
        loaders.push(baseApi.loadCompany(activeOrgnum));
        loaders.push(baseApi.loadUser());
    }
    const doneLoading = Promise.all(loaders);

    return {
        store: store,
        baseApi: baseApi,
        geoApi: geoApi,
        doneLoading: doneLoading,
    };
};
